import React from 'react';
import './Coffee.css';

const Coffee = () => {
  return (
    <section id="cafe" className="coffee">
      <div className="container">
        <div className="coffee-header">
          <h2 className="section-title">Cafetería & Desayuno</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Comienza tu día con el mejor café y un delicioso desayuno incluido
          </p>
        </div>

        <div className="coffee-content">
          <div className="coffee-main">
            <div className="coffee-image-placeholder">
              <div className="image-icon">☕</div>
              <p>Café de calidad premium</p>
            </div>
            <div className="coffee-text">
              <h3>Nuestro Café</h3>
              <p>
                En KAWILA no solo ofrecemos alojamiento, también brindamos una experiencia
                gastronómica única. Nuestra cafetería es el corazón del hostal, donde
                nuestros huéspedes pueden disfrutar de un excelente café salvadoreño y
                conocer a otros viajeros.
              </p>
              <p>
                Utilizamos granos de café de la más alta calidad, cuidadosamente
                seleccionados de las mejores fincas de El Salvador. Cada taza es preparada
                con dedicación para ofrecerte la mejor experiencia de café.
              </p>
            </div>
          </div>

          <div className="breakfast-section">
            <h3>Desayuno Incluido</h3>
            <p className="breakfast-intro">
              Tu estadía incluye un delicioso desayuno para comenzar el día con energía:
            </p>
            <div className="breakfast-features">
              <div className="breakfast-card">
                <div className="breakfast-icon">🥐</div>
                <h4>Opciones Variadas</h4>
                <p>Desayuno continental con opciones frescas y nutritivas cada día</p>
              </div>
              <div className="breakfast-card">
                <div className="breakfast-icon">🍳</div>
                <h4>Platos Típicos</h4>
                <p>Prueba auténticos sabores salvadoreños en el desayuno</p>
              </div>
              <div className="breakfast-card">
                <div className="breakfast-icon">☕</div>
                <h4>Café Ilimitado</h4>
                <p>Disfruta de nuestro café premium sin límite durante el desayuno</p>
              </div>
            </div>
          </div>

          <div className="coffee-highlights">
            <div className="highlight-item">
              <span className="highlight-number">01</span>
              <div className="highlight-content">
                <h4>Café de Origen</h4>
                <p>Granos 100% salvadoreños de las mejores fincas locales</p>
              </div>
            </div>
            <div className="highlight-item">
              <span className="highlight-number">02</span>
              <div className="highlight-content">
                <h4>Preparación Artesanal</h4>
                <p>Cada café es preparado con técnicas especializadas</p>
              </div>
            </div>
            <div className="highlight-item">
              <span className="highlight-number">03</span>
              <div className="highlight-content">
                <h4>Ambiente Acogedor</h4>
                <p>Espacio perfecto para relajarte y socializar</p>
              </div>
            </div>
          </div>

          <div className="coffee-cta">
            <p>
              <strong>¿Amante del café?</strong> Ven a descubrir por qué el café salvadoreño
              es reconocido mundialmente. En KAWILA, cada taza cuenta una historia.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Coffee;
